//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    width: 90%;
`;